import type { Citation, ChatMessage } from '@/types/chat';

const UUID_KEY = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/** Saved citations are keyed by uuid, streamed ones by index. */
export const isPersistedCitationId = (id: string): boolean => UUID_KEY.test(id);

/**
 * Resolves the canonical citation map for a chat: the chat-level `citations` from `GET /chat`,
 * falling back to legacy per-message citations, with in-flight streaming ones overlaid.
 */
export const resolveChatCitations = (
  chatLevelCitations: Record<string, Citation> | undefined,
  messages: ChatMessage[],
): Record<string, Citation> => {
  const resolved: Record<string, Citation> = {};

  const hasChatLevel = chatLevelCitations && Object.keys(chatLevelCitations).length > 0;
  if (hasChatLevel) {
    Object.assign(resolved, chatLevelCitations);
  } else {
    for (const msg of messages) {
      if (!msg.citations) continue;
      for (const [id, citation] of Object.entries(msg.citations)) {
        if (!resolved[id]) resolved[id] = citation;
      }
    }
  }

  for (const msg of messages) {
    if (!msg.citations) continue;
    for (const [id, citation] of Object.entries(msg.citations)) {
      if (!UUID_KEY.test(id) || !(id in resolved)) {
        resolved[id] = citation;
      }
    }
  }

  return resolved;
};
